import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {BankStatementsPage} from './components/BankStatementsPage';
import {ContentRoute, LayoutSplashScreen} from '../../../_metronic/layout';

export default function BankStatementsPageContainer() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/bank-statements" component={BankStatementsPage}/>
      </Switch>
    </Suspense>
  );
}
